// extracted by mini-css-extract-plugin
export var notificationHost = "_jx-0";